import axios from 'axios';
import config from './config';

const hostUrl = config.hostUrl;

// function sleep(ms = 1000) {
//   console.log('Kindly remember to remove `sleep`');
//   return new Promise((resolve) => setTimeout(resolve, ms));
// }

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  baseURL: hostUrl
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      const basePath = config.homepage || '';
      const loginPath = `${basePath}/login`;
      const currentPath =
        window.location.pathname +
        window.location.search +
        window.location.hash;

      localStorage.removeItem('token');
      delete axiosInstance.defaults.headers.common['x-auth-token'];

      if (!window.location.pathname.endsWith('/login')) {
        sessionStorage.setItem('postLoginRedirect', currentPath);
        window.location.assign(loginPath);
      }
    }

    return Promise.reject(error);
  }
);

// axiosInstance.interceptors.response.use(async (response) => {
//   if (process.env.NODE_ENV === 'development') {
//     await sleep();
//   }
//   return response;
// });


export default axiosInstance;
